


import React, { useEffect, useRef, forwardRef, useState } from "react";
import { useLocation } from 'react-router-dom';
import { subDays } from 'date-fns'

// material
import { makeStyles } from '@mui/styles';


import {
  Box, Button, Typography, Container,
  Card,
  Grid,
  Chip,
  Tab,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
  TextField,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Slide,
  Tooltip,
  LinearProgress,
  Skeleton
} from '@mui/material';

import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import VolumeUpOutlinedIcon from '@mui/icons-material/VolumeUpOutlined';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

import { crossMarkString, crossMarkDeviceIdString, showLanguageLabelUsingCode, getTransactionAnnouncedOrNot, parseValidationErrorMessage,getBatteryPerceByVBAT } from '../utils/Utilities'
import { isoDateFToNow,getDateINYMD } from "../utils/formatTime";
import { fShortenNumber } from '../utils/formatNumber'
import AlertDialog from "../components/AlertDialog";


// components
import Page from '../components/Page';
import { DeviceEventRequestByServer, GetDeviceById, GetDeviceDeatilsById, GetDeviceTransactions, GetDevicePaymentStats } from "../network/Device";
import {GetTransactionHistory} from '../network/Organization'
import { DeviceLanguageChangeModal } from '../components/_dashboard/soundbox'
import { GetAllMerchants, GetMerchantOnlineStatus } from "../network/Merchants";
import { useAuth } from "../components/customContextProviders/AuthContext";
import { APP_CONSTANTS } from "../URLConstants";


// ----------------------------------------------------------------------


const useStyles = makeStyles({

  cardWithBorder: {
    background: "#FFFFFF",
    border: " 1px solid #B0B9C7",
    boxShadow: "0px 10px 19px 1px #EAEAFF",
    boxSizing: "border-box",
    borderRadius: "20px",
    flexGrow: 1,
    marginRight: "-10px",
  },
  backGroundRed: {
    background: "rgba(195, 10, 10, .1)"
  },
  backGroundWhite: {
    background: 'white'
  }
});

/* eslint-disable */
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
/* eslint-enable */

let currentPage = 1


export default function SoundBoxDeviceDetails() {

  const { sessionUserData } = useAuth()

  const location = useLocation();
  const classes = useStyles();

  const [deviceDetails, setDeviceDetails] = useState({ data: {}, deviceData: {}, loading: false, onlineStatus: {}, onlineStatusLoading: false });
  const [deviceTransactionsListMetas, setDeviceTransactionsListMetas] = useState({ data: [], meta: {}, loading: false })
  const [isDeviceLangugeChangeModalOpen, setIsDeviceLangugeChangeModalOpen] = useState(false)
  const [isRebootRequestDialogOpen, setIsRebootRequestDialogOpen] = useState(false)

  const transacTableRef = useRef(null);

  const [openAlertDialog, setOpenAlertDialog] = useState(false)
  const [alertDialogMetas, setAlertDialogMetas] = useState({
    message: "",
    title: "",
    btnLabel: "",

  });

  const [totalAmount, setTotalAmount] = useState(null);



  useEffect(() => {
    getDetailsUsingDandMId()
    const startDate= getDateINYMD(new Date())
    const endDate=  getDateINYMD(new Date())
    fetchAndCalculateTotalAmount(
      startDate, 
      endDate, 
      {"merchant_identifier": location?.state?.merchantId}
    );


    return () => {
    }
  }, []);

  const [graphTabValue, setGraphTabValue] = useState('BATTERY');
  const [transactionsTabValue, setTransactionsTabValue] = useState('today');

  const getDefaultLimitValue = (tabType) => {
    if (tabType === 'today')
      return 10
    if (tabType === 'last_3_day')
      return 10
    if (tabType === 'all')
      return 10
  }


  const handleGraphTabValueChange = (_event, newValue) => {
    setGraphTabValue(newValue);
  };


  const handleRebootConfirmDialogClose = (_event) => {
    setIsRebootRequestDialogOpen(false)
  }



  function getDetailsUsingDandMId() {


    if (location?.state?.deviceId !== undefined && location?.state?.deviceId !== null) {
      getSoundBoxDeviceDetails(location.state?.organizationId !== undefined && location.state?.organizationId !== null && location.state?.organizationId !== '' ?
        location.state?.organizationId : ""
        , location?.state?.deviceId)

      fetchDeviceTransactions(location.state?.organizationId !== undefined && location.state?.organizationId !== null && location.state?.organizationId !== '' ?
        location.state?.organizationId : ""
        , location?.state?.deviceId,
        "today", 1, 10);

    }
    else {

        const where={"organizationId":location.state?.organizationId !== undefined && location.state?.organizationId !== null && location.state?.organizationId !== '' ?
        location.state?.organizationId : "",key:location?.state?.merchantId}

       const startDate= getDateINYMD(new Date())
        const endDate=  getDateINYMD(new Date())
    

      getAudioCubeMerchantDetails(where)

      fetchMerchantTransactions(location.state?.organizationId !== undefined && location.state?.organizationId !== null && location.state?.organizationId !== '' ?
        location.state?.organizationId : ""
        , location?.state?.merchantId,
        startDate,endDate, 1, 10, "SEARCH")

      


    }

  }

  function getSoundBoxDeviceDetails(organizationId, deviceId) {
    // setDeviceDetails({ ...deviceDetails, loading: true })

    setDeviceDetails(deviceDetails => ({
      ...deviceDetails,
      loading: true
    }))

    GetDeviceById(organizationId, deviceId).then((res) => {
      //  setDeviceDetails({ ...deviceDetails, data: res?.data?.data?.lists?.[0], loading: false })

      setDeviceDetails(deviceDetails => ({
        ...deviceDetails,
        data: res?.data?.data?.lists?.[0], loading: false
      }))



    }).catch((_error) => {
      setDeviceDetails({ ...deviceDetails, loading: false })

    })

  }

  function fetchDeviceDetailsById(deviceId) {
    if(!deviceId) return;

    GetDeviceDeatilsById(deviceId).then((res) => {
            
      setDeviceDetails(deviceDetails => ({
        ...deviceDetails,
        deviceData: res?.data?.data?.state?.reported,
      }))

    }).catch((_err) => {

    })

  }

  function getAudioCubeMerchantDetails(where) {
    setDeviceDetails({ ...deviceDetails, loading: true })


    GetAllMerchants(1, 10, where).then((res) => {
      // setDeviceDetails({ ...deviceDetails, })
      setDeviceDetails(deviceDetails => ({
        ...deviceDetails,
        data: res?.data?.data?.[0], 
        loading: false
      }))


      if (res?.data?.data?.lists?.[0]?.device_id !== null && res?.data?.data?.[0]?.device_id !== undefined)
        fetchMerchantOnlineStatus(res?.data?.data?.[0]?.device_id)

      if (res?.data?.data?.lists?.[0]?.device_id !== null && res?.data?.data?.[0]?.device_id !== undefined) {
        fetchDeviceDetailsById(res?.data?.data?.[0]?.device_id)
      }


    }).catch((_error) => {
      // setDeviceDetails({ ...deviceDetails, loading: false })

      setDeviceDetails(deviceDetails => ({
        ...deviceDetails,
        loading: false
      }))
    })
  }


  function fetchMerchantOnlineStatus(deviceId) {
    if (!deviceId) return;

    setDeviceDetails(prevState => ({
      ...prevState,
      onlineStatusLoading: true,
    }));

    GetMerchantOnlineStatus(deviceId).then((res) => {
      setDeviceDetails(prevState => ({
        ...prevState,
        onlineStatus: res?.data?.data,
        onlineStatusLoading: false,
      }));

    }).catch((_err) => {
      setDeviceDetails(prevState => ({
        ...prevState,
        onlineStatusLoading: false,
      }));
    })
  }

  function fetchDeviceTransactions(organizationId, deviceId, filterType, pageNo, limit) {

    setDeviceTransactionsListMetas({ ...deviceTransactionsListMetas, loading: true })

    GetDeviceTransactions(organizationId, deviceId, filterType, '', pageNo, limit).then((res) => {

      setDeviceTransactionsListMetas(prevState => ({
        ...prevState,
        data: [
          ...(prevState?.data ?? []),
          ...(res?.data?.data?.lists ?? [])
        ],
        meta: res?.data,
        loading: false
      }));

     


    }).catch((_err) => {
      setDeviceTransactionsListMetas({ ...deviceTransactionsListMetas, loading: false })
    })
  }

  function fetchMerchantTransactions(organizationId, merchantId, startDate,endDate, pageNo, limit, type) {

    setDeviceTransactionsListMetas({ ...deviceTransactionsListMetas, loading: true })


    const where={
      "merchant_identifier":merchantId,
      "organizationId":organizationId,
    }


    GetTransactionHistory(pageNo, limit,where,startDate,endDate).then((res) => {
      if (type === "SEARCH")
      setDeviceTransactionsListMetas({ ...deviceTransactionsListMetas, data: res?.data?.data, meta: res?.data, loading: false })
    else if (type === "ADD")
      setDeviceTransactionsListMetas(prevState => ({
        ...prevState,
        data: [
          ...(prevState?.data ?? []),
          ...(res?.data?.data ?? [])
        ],
        meta: res?.data,
        loading: false
      }));

    



    }).catch((_err) => {
       setDeviceTransactionsListMetas({ ...deviceTransactionsListMetas, loading: false })

    })





    // GetMerchantTransactions(organizationId, merchantId, filterType, serachBy, pageNo, limit).then((res) => {
    //   if (type === "SEARCH")
    //     setDeviceTransactionsListMetas({ ...deviceTransactionsListMetas, data: res?.data?.data?.lists, meta: res?.data?.data, loading: false })
    //   else if (type === "ADD")
    //     setDeviceTransactionsListMetas(prevState => ({
    //       ...prevState,
    //       data: [
    //         ...(prevState?.data ?? []),
    //         ...(res?.data?.data?.lists ?? [])
    //       ],
    //       meta: res?.data?.data,
    //       loading: false
    //     }));

    // }).catch((err) => {
    //   setDeviceTransactionsListMetas({ ...deviceTransactionsListMetas, loading: false })
    // })
  }



  function callDeviceRebootRequets(_merchantServerId, _deviceServerId, _merchantDeviceId) {
    if (deviceDetails?.data?.device_id === null || deviceDetails?.data?.device_id === undefined) {
      setAlertDialogMetas({ ...alertDialogMetas, message: 'Device is not assigned yet', title: "Device not assigned", btnLabel: "OK" });
      setOpenAlertDialog(true)
      return
    }


    if (getonlineLabelBasedOnStatus(deviceDetails?.onlineStatus) === 'OFFLINE') {
      setAlertDialogMetas({ ...alertDialogMetas, message: 'Device is offline now ', title: "Device Offline", btnLabel: "OK" });
      setOpenAlertDialog(true)
      return
    }
    setIsRebootRequestDialogOpen(true)
  }

  function rebootDevice(merchantServerId, merchantDeviceId) {
    DeviceEventRequestByServer(location.state?.organizationId !== undefined && location.state?.organizationId !== null && location.state?.organizationId !== '' ?
      location.state?.organizationId : "", merchantServerId, merchantDeviceId, "DEVICE_REBOOT", new Date().getTime(), "")
      .then((_res) => {
        setAlertDialogMetas({ ...alertDialogMetas, message: 'Device rebooted successfully', title: "Rebooted", btnLabel: "OK" });
        setOpenAlertDialog(true)

      }).catch((err) => {
        setAlertDialogMetas({ ...alertDialogMetas, message: parseValidationErrorMessage(err), title: "Failed to process request", btnLabel: "OK" });
        setOpenAlertDialog(true)
      })
  }

  function callDeviceLanguageChangeRequet() {

    if (deviceDetails?.data?.device_id === null || deviceDetails?.data?.device_id === undefined) {
      setAlertDialogMetas({ ...alertDialogMetas, message: 'Device is not assigned yet', title: "Device not assigned", btnLabel: "OK" });
      setOpenAlertDialog(true)
      return
    }



    if (getonlineLabelBasedOnStatus(deviceDetails?.onlineStatus) === 'OFFLINE') {
      setAlertDialogMetas({ ...alertDialogMetas, message: 'Device is offline now ', title: "Device Offline", btnLabel: "OK" });
      setOpenAlertDialog(true)
      return
    }


    setIsDeviceLangugeChangeModalOpen(true)
  }

  function onDeviceLanguageChangeModalAction(msg) {
    setAlertDialogMetas({ ...alertDialogMetas, message: msg, title: "", btnLabel: "OK" });
    setOpenAlertDialog(true)
  }

  const handleScroll = () => {
    const card = transacTableRef.current;
    if (!card) return;

    const scrollPercentage = (card.scrollTop / (card.scrollHeight - card.clientHeight)) * 100;
    if (scrollPercentage <= 90 || !deviceTransactionsListMetas?.meta?.hasNextPage || deviceTransactionsListMetas?.loading) return;

    currentPage += 1;

    const getStartAndEndDate = (tabValue) => {
        const today = new Date();
        switch (tabValue) {
            case "today":
                return { startDate: getDateINYMD(today), endDate: getDateINYMD(today) };
            case "last_3_day":
                return { startDate: getDateINYMD(subDays(today, 3)), endDate: getDateINYMD(today) };
            case "all":
                return { startDate: getDateINYMD(subDays(today, 365)), endDate: getDateINYMD(today) };
            default:
                return { startDate: "", endDate: "" };
        }
    };

    const { startDate, endDate } = getStartAndEndDate(transactionsTabValue);

    const organizationId = location.state?.organizationId ?? "";
    fetchMerchantTransactions(organizationId, location?.state?.merchantId, startDate, endDate, currentPage, 10, "ADD");
};


  const getonlineLabelBasedOnStatus = (onlineStatus) => {
    if (onlineStatus?.state?.reported?.presence?.status === 'disconnected')
      return "OFFLINE"
    if (onlineStatus?.state?.reported?.presence?.status === 'connected')
      return "ONLINE"

    return "---"

  }

 

  function getStartDateEndDateByTabValue(tabValue){
   
    let startDate=""
    let endDate=""

    if(tabValue==="today"){
      startDate= getDateINYMD(new Date())
      endDate=  getDateINYMD(new Date())
    }else if(tabValue==="last_3_day"){
      startDate=getDateINYMD(subDays(new Date(), 3))
      endDate=  getDateINYMD(new Date())
    }else if(tabValue==="all"){
      startDate= getDateINYMD(subDays(new Date(), 150))
      endDate=  getDateINYMD(new Date())
    }
  
    return {startDate, endDate};
  }


const fetchAndCalculateTotalAmount = (startDate, endDate, where) => {
  GetDevicePaymentStats(startDate, endDate, where)
      .then((res) => {
          const totalAmount = res?.data?.data?.sum;
          setTotalAmount(totalAmount); 
          return totalAmount; 
      })
      .catch((_err) => {

      });
};
  

  const handleTransactionsTabValueChange = (_event, newValue) => {
    currentPage = 1;
    const dateRange = getStartDateEndDateByTabValue(newValue);
    const startDate = dateRange?.startDate;
    const endDate = dateRange?.endDate;

    setTransactionsTabValue(newValue);
    try {
        if (location?.state?.deviceId !== undefined && location?.state?.deviceId !== null) {
            fetchDeviceTransactions(
            location.state?.organizationId || "",
            location?.state?.deviceId,
            newValue, 1, getDefaultLimitValue(newValue)
          );
        } else {
            fetchMerchantTransactions(
            location.state?.organizationId || "",
            location?.state?.merchantId,
            startDate, endDate, 1, getDefaultLimitValue(newValue), "SEARCH"
          );
        } 

        fetchAndCalculateTotalAmount(
          dateRange?.startDate, 
          dateRange?.endDate, 
          {"merchant_identifier": location?.state?.merchantId}
        );


    } catch (error) {
        console.error("Error fetching transactions or total amount:", error);
    }
};





  return (
    <Page title="Merchant Detail">
      <Container maxWidth="false">
        <Typography className="font20 fontWeight700 " sx={{ mt: 1, mb:1, fontFamily: 'Montserrat', pl:1}}>{deviceDetails?.data?.name} </Typography>
        <Grid container spacing={2} >
          <Grid item xs={12} sm={12} md={8}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={7}>
                <Grid container spacing={2} >
                  <Grid item xs={12} sm={6} md={6} >
                    {deviceDetails?.loading ? (
                      <Skeleton variant="rounded" width='100%' height={120} />
                    ) : (
                      <Card
                        sx={{
                          p: 1,
                          minHeight: 120,
                          backgroundColor: '#FFF',
                          boxShadow: '0px 10px 19px 1px #EAEAFF',
                          borderRadius: '10px',
                        }}
                      >
                        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                          {deviceDetails?.onlineStatusLoading ? (
                            <Typography>Please wait...</Typography>
                          ) : (
                            <Chip
                              sx={{
                                '& .MuiChip-label': {
                                  color: 'white',
                                  fontSize: '12px',
                                },
                                '& .MuiChip-deleteIcon': {
                                  color: '#FFFFFF'
                                },
                                height: '24px',
                                float: 'end',
                              }}
                              data-testid='status-chip'
                              deleteIcon={<RefreshOutlinedIcon />}
                              onDelete={() => {fetchMerchantOnlineStatus(deviceDetails?.data?.device_id)
                              fetchDeviceDetailsById(deviceDetails?.data?.device_id)
                            }}
                              label={getonlineLabelBasedOnStatus(deviceDetails?.onlineStatus)}
                              variant="contained"
                              color={getonlineLabelBasedOnStatus(deviceDetails?.onlineStatus) === 'ONLINE' ? 'success' : 'error'}
                            />
                          )}
                        </Box>
                        <Typography className="merchantIdLabel">{crossMarkString(deviceDetails?.data?.key)}</Typography>
                        <Stack direction="row" justifyContent="center" alignItems="flex-start" spacing={1} mt={1}>
                          <Typography className="deviceStatusLabel textGreen">Device Status : </Typography>
                          <Typography className="deviceStatusLabel">{deviceDetails?.data?.activated ? "Assigned" : "Not Assigned"}</Typography>
                        </Stack>
                      </Card>
                    )}

                  </Grid>
                  <Grid item xs={12} sm={6} md={6} alignItems='center'>
                    {
                      deviceDetails?.loading ? (
                        <Skeleton variant="rounded" width="100%" height={120} />
                      ) : (
                        <Card sx={{ p: 1, minHeight: 120, backgroundColor: '#FFF', boxShadow: '0px 10px 19px 1px #EAEAFF;', borderRadius: '10px' }}>

                          <Grid container spacing={2} alignItems='center'>

                            <Grid item xs={6} sm={6} md={6}>

                              <Stack
                                direction="column"
                                justifyContent="center"
                                alignItems="center"
                                spacing={1}
                                mt={1}
                                sx={{ minHeight: 80 }}
                              >
                                <Typography className="font24 fontWeight800 ">--- </Typography>
                                <Typography className="font14 textGray " sx={{ textAlign: 'center' }}>Active <br /> Complaints </Typography>
                              </Stack>


                            </Grid>

                            <Grid item xs={6} sm={6} md={6}>

                              <Stack
                                direction="column"
                                justifyContent="center"
                                alignItems="center"
                                spacing={1}
                                mt={1}
                                sx={{ minHeight: 80 }}
                              >
                                <Typography className="font24 fontWeight800">--- </Typography>
                                <Typography className="font14 textGray" sx={{ textAlign: 'center' }}>Resolved <br /> Complaints</Typography>
                              </Stack>


                            </Grid>

                          </Grid>


                        </Card>
                      )}
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} justify="center" alignItems="center">
                    {
                      deviceDetails?.loading ? (
                        <Skeleton variant="rounded" width="100%" height={120} />
                      ) : (
                        <Card sx={{ p: 1, minHeight: 120, backgroundColor: '#FFF', boxShadow: '0px 10px 19px 1px #EAEAFF;', borderRadius: '10px' }}>

                          <Typography className="deviceStatusLabel textGreen font14">Current Language  </Typography>


                          <Stack
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            spacing={2}
                            mt={1}
                            sx={{ minHeight: 80 }}

                          >

                            <Stack
                              direction="column"
                              justifyContent="center"
                              alignItems="flex-start"
                              spacing={1}
                              mt={1}

                            >
                              <Box sx={{ display: 'flex', gap:1 }}>
                                <Typography className="deviceStatusLabel textGreen font14">L1 : </Typography>
                                <Typography className="deviceStatusLabel font14">  {showLanguageLabelUsingCode(deviceDetails?.data?.language)}</Typography>
                              </Box>

                              <Box sx={{ display: 'flex',gap:1 }}>
                                <Typography className="deviceStatusLabel textGreen font14">L2 : </Typography>
                                <Typography className="deviceStatusLabel font14"> ---</Typography>
                              </Box>

                            </Stack>

                            <Button variant="contained" data-testid='language-change-button' className="secondayDashboardButton" onClick={() => callDeviceLanguageChangeRequet()} >Change</Button>


                          </Stack>


                        </Card>
                      )}
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    {
                      deviceDetails?.loading ? (
                        <Skeleton variant="rounded" width="100%" height={120} />
                      ) : (
                        <Card sx={{ p: 1, minHeight: 120, backgroundColor: '#FFF', boxShadow: '0px 10px 19px 1px #EAEAFF;', borderRadius: '10px' }}>
                          <Typography className="deviceStatusLabel textGreen font14">Custom Message  </Typography>
                          <Stack
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            spacing={1}
                            mt={1}
                            sx={{ minHeight: 80 }}
                          >
                            <Typography className="font14 fontWeight700 ">---- </Typography>
                            <Button variant="contained" data-testid='message-button' className="secondayDashboardButton" onClick={() => {
                              setAlertDialogMetas({ ...alertDialogMetas, message: "This feature is coming soon, please keep checking this space!", title: "", btnLabel: "OK" });
                              setOpenAlertDialog(true)

                            }}  >Change</Button>
                          </Stack>
                        </Card>
                      )}
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} md={5}>

                {
                  deviceDetails?.loading ? (
                    <Skeleton variant="rounded" sx={{ height: '100%',  width:"100%" }} />
                  ) : (
                    <Card sx={{ p: 1, height: '100%', backgroundColor: '#FFF', boxShadow: '0px 10px 19px 1px #EAEAFF;', borderRadius: '10px' }}>
                      <TabContext value={graphTabValue}>

                        <TabList sx={{
                          '& .MuiTabs-flexContainer': {
                            justifyContent: 'center'
                          }
                        }} onChange={handleGraphTabValueChange} aria-label="lab API tabs example">
                          <Tab label="Transactions" value="BATTERY" />
                          <Tab label="Battery Data" value="TRANSACTIONS" />
                        </TabList>

                        <TabPanel value="BATTERY">

                          <Stack
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                            spacing={1}
                            mt={1}>

                            {/* <img alt="coming soon" width="80" src="/static/icons/coming_soon.jpg" /> */}
                            <Typography>Coming Soon</Typography>

                          </Stack>


                        </TabPanel>
                        <TabPanel value="TRANSACTIONS">

                          <Stack
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                            spacing={1}
                            mt={1}>

                            {/* <img alt="coming soon" width="80" src="/static/icons/coming_soon.jpg" /> */}
                            <Typography>Coming Soon</Typography>

                          </Stack>

                        </TabPanel>

                      </TabContext>

                    </Card>
                  )}

              </Grid>
            </Grid>
            <Grid item xs={12} md={12} mt={2}>
              {
                deviceDetails?.loading ? (
                  <Skeleton variant="rounded" width="100%" sx={{ height: 250 }} />
                ) : (
                  <>
                    <Card data-testid='device-details-card' sx={{ p: 2, minHeight: 120, backgroundColor: '#FFF', boxShadow: '0px 10px 19px 1px #EAEAFF;', borderRadius: '10px' }}>

                      <Grid container spacing={2} >

                        <Grid item xs={6} sm={6} md={3}>
                          <Typography className="font14 textGray fontWeight700">Device ID</Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={3}>
                          <Typography className="font14 fontWeight600">
                          {
                            sessionUserData?.user?.role !== APP_CONSTANTS?.USER_ROLE_SUPER_ADMIN &&
                            sessionUserData?.user?.role !== APP_CONSTANTS?.L1_SUPPORT_USER_ROLE &&
                            sessionUserData?.user?.role !== APP_CONSTANTS?.L2_SUPPORT_USER_ROLE
                            ?
                            crossMarkDeviceIdString(deviceDetails?.data?.device_id)
                            :
                              (deviceDetails?.data?.device_id)
                          }
                          </Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={3}>
                          <Typography className="font14 textGray fontWeight700">Battery</Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={3}>

                          <Typography className="font14 fontWeight600">{ getBatteryPerceByVBAT(deviceDetails?.deviceData?.VBAT)} %</Typography>
                        </Grid>

                        {/* <Grid item sx={6} sm={6} md={3}>
                        <Typography className="font14 textGray fontWeight700">SIM no</Typography>
                      </Grid>
                      <Grid item sx={6} sm={6} md={3}>
                        <Typography className="font14 fontWeight700">{crossMarkString(deviceDetails?.deviceData?.sim)}</Typography>
                      </Grid> */}
                        <Grid item xs={6} sm={6} md={3}>
                          <Typography className="font14 textGray fontWeight700">Notifications Missed</Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={3}>
                          <Typography className="font14 fontWeight600">{deviceDetails?.data?.missed}</Typography>
                        </Grid>

                        <Grid item xs={6} sm={6} md={3}>
                          <Typography className="font14 textGray fontWeight700">Zone</Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={3}>
                          <Typography className="font14 fontWeight600">{deviceDetails?.data?.merchantbranch?.zone}</Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={3}>
                          <Typography className="font14 textGray fontWeight700">Messages Sent</Typography>
                        </Grid>
                        <Grid item x={6} sm={6} md={3}>

                          <Typography className="font14 fontWeight600">{deviceDetails?.data?.total_message}</Typography>
                        </Grid>


                        <Grid item xs={6} sm={6} md={3}>
                          <Typography className="font14 textGray fontWeight700">City</Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={3}>
                          <Typography className="font14 fontWeight600">{deviceDetails?.data?.city}</Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={3}>
                          <Typography className="font14 textGray fontWeight700">Messages Delivered</Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={3}>
                          <Typography className="font14 fontWeight600">{deviceDetails?.data?.delivered}</Typography>
                        </Grid>

                        <Grid item xs={6} sm={6} md={3}>
                          <Typography className="font14 textGray fontWeight700">State</Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={3}>
                          <Typography className="font14 fontWeight600">{deviceDetails?.data?.state}</Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={3}>
                        <Typography className="font14 textGray fontWeight700">Reboot Count</Typography>
                      </Grid>
                      <Grid item xs={6} sm={6} md={3}>
                        <Typography className="font14 fontWeight600">{deviceDetails?.data?.reboot_count}</Typography>
                      </Grid>


                        <Grid item xs={6} sm={6} md={3}>
                          <Typography className="font14 textGray fontWeight700">Rent Collected</Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={3}>

                          <Typography className="font14 fontWeight600">{deviceDetails?.data?.rent_to_be_collected}</Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={3}>
                          <Typography className="font14 textGray fontWeight700">Onboarding Channel</Typography>
                        </Grid>

                        <Grid item xs={6} sm={6} md={3}>
                          <Typography className="font14 fontWeight600">{deviceDetails?.data?.onboarding_channel}</Typography>
                        </Grid>


                      </Grid>
                    </Card>

                    {
                      (sessionUserData?.user?.role === APP_CONSTANTS?.L1_SUPPORT_USER_ROLE || sessionUserData?.user?.role === APP_CONSTANTS?.L2_SUPPORT_USER_ROLE 
                      || sessionUserData?.user?.role ===APP_CONSTANTS?.USER_ROLE_SUPER_ADMIN)
                      &&


                        <Card sx={{ p: 2, mt: 2, minHeight: 120, backgroundColor: '#FFF', boxShadow: '0px 10px 19px 1px #EAEAFF;', borderRadius: '10px' }}>
                          <Grid container spacing={2}>

                            <Grid item xs={6} sm={6} md={3}>
                              <Typography className="font14 textGray fontWeight700">Device ID :</Typography>
                            </Grid>


                            <Grid item xs={6} sm={6} md={3}>
                              <Typography className="font14 fontWeight600">{(deviceDetails?.data?.device_id)}</Typography>
                            </Grid>


                            <Grid item xs={6} sm={6} md={3}>
                              <Typography className="font14 textGray fontWeight700">CSQ:</Typography>
                            </Grid>


                            <Grid item xs={6} sm={6} md={3}>
                              <Typography className="font14 fontWeight600">{deviceDetails?.deviceData?.CSQ}</Typography>
                            </Grid>


                            <Grid item xs={6} sm={6} md={3}>
                              <Typography className="font14 textGray fontWeight700">Charger</Typography>
                            </Grid>


                            <Grid item xs={6} sm={6} md={3}>
                              <Typography className="font14 fontWeight600">{deviceDetails?.deviceData?.CHARGER === "1" ? "Plugged-In" : "Plugged-Out"}</Typography>
                            </Grid>


                            <Grid item xs={6} sm={6} md={3}>
                              <Typography className="font14 textGray fontWeight700">Volume</Typography>
                            </Grid>


                            <Grid item xs={6} sm={6} md={3}>
                              <Typography className="font14 fontWeight600">{deviceDetails?.deviceData?.VOLUME}</Typography>
                            </Grid>


                            <Grid item xs={6} sm={6} md={3}>
                              <Typography className="font14 textGray fontWeight700">SIM</Typography>
                            </Grid>


                            <Grid item xs={6} sm={6} md={3}>
                              <Typography className="font14 fontWeight600">{crossMarkString(deviceDetails?.deviceData?.CCID)}</Typography>
                            </Grid>


                            <Grid item xs={6} sm={6} md={3}>
                              <Typography className="font14 textGray fontWeight700">Reboot Count</Typography>
                            </Grid>

                            <Grid item xs={6} sm={6} md={3}>
                              <Typography className="font14 fontWeight600">{deviceDetails?.data?.reboot_count}</Typography>
                            </Grid>


                          </Grid>
                        </Card>
                    }

                  </>
                )}
            </Grid>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
              mt={3}
            >
              <Stack
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={.5}
              >

                <Typography className="font14 fontWeight700">FW Version {crossMarkString(deviceDetails?.deviceData?.FWV)}</Typography>
                <Typography className="font14 fontWeight700">Last Updated  {isoDateFToNow(deviceDetails?.data?.last_activity_date)}</Typography>

              </Stack>

              <Button variant="contained" data-testid='reboot-button' className="secondayDashboardButton" onClick={() =>
                callDeviceRebootRequets(deviceDetails?.data?.merchantautoid, deviceDetails?.data?.deviceautoid,
                  deviceDetails?.data?.device_id)
              } >Reboot</Button>
            </Stack>
          </Grid>

          <Grid item xs={12} sm={12} md={4} >
            <Card data-testid='trans-card' className={classes?.cardWithBorder} sx={{ maxHeight: 580, height: 620, overflow: 'hidden' }}>
              {deviceTransactionsListMetas?.loading && <LinearProgress color="success" />}
              <Box sx={{ mt: 2, }}>
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}
                  mt={1}
                  pl={2}
                  pr={2}
                  sx={{ minHeight: 80 }}
                >
                  <Typography sx={{ p: 2, fontWeight: 700, mb: 1, fontSize: "18px", lineHeight: "23px", color: "#171D40" }}>Transactions</Typography>
                  <TextField size="small" label="Transaction ID" />
                </Stack>

                <TabContext value={transactionsTabValue}>

                  <TabList sx={{
                    '& .MuiTabs-flexContainer': {
                      justifyContent: 'center'
                    }
                  }} onChange={handleTransactionsTabValueChange} aria-label="lab API tabs example">
                    <Tab data-testid='today-tab' label="Today" value="today" />
                    <Tab data-testid='3day-tab' label="Last 3 Days" value="last_3_day" />
                    <Tab data-testid='all-time-tab' label="All Time" value="all" />

                  </TabList>

                  <TabPanel value="today" >
                    <TableContainer sx={{ maxHeight: 350, overflow: 'scroll', }} ref={transacTableRef} onScroll={handleScroll}>
                      <Table aria-label="transactions table" stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell className="font12 fontWeight800">Trans. ID</TableCell>
                            <TableCell className="font12 fontWeight800" align="center" ><VolumeUpOutlinedIcon /></TableCell>
                            <TableCell className="font12 fontWeight800" align="left" sx={{ minWidth: '7vw' }}>Amount</TableCell>
                            <TableCell className="font12 fontWeight800" align="center" sx={{ minWidth: '10vw' }}>Date & Time</TableCell>

                          </TableRow>
                        </TableHead>
                        <TableBody>

                          {
                            deviceTransactionsListMetas?.data?.length > 0 &&
                              deviceTransactionsListMetas?.data?.map((row) => (
                                <TableRow
                                  className="font12"
                                  key={row?.id}
                                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                  <TableCell className="font12" component="th" scope="row">
                                    {crossMarkString(row?.id)}
                                  </TableCell>
                                  <TableCell className="font12" align="center">{getTransactionAnnouncedOrNot(row?.status)}</TableCell>

                                  <TableCell className="font12" align="center" >
                                    <Stack direction="row" alignItems="center">
                                      <CurrencyRupeeIcon sx={{ fontSize: '14px' }} />
                                      <Typography className="font12" sx={{ textAlign: 'center' }}> {row?.amount}</Typography>
                                    </Stack>
                                  </TableCell>
                                  <TableCell className="font12" align="center">{isoDateFToNow(row?.payment_date)}</TableCell>
                                </TableRow>
                              ))
                          }
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </TabPanel>
                  <TabPanel value="last_3_day" >

                    <TableContainer sx={{ maxHeight: 350, overflow: 'scroll', }} ref={transacTableRef} onScroll={handleScroll}>
                      <Table aria-label="transactions table" stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell className="font12 fontWeight800">Trans. ID</TableCell>
                            <TableCell className="font12 fontWeight800" align="center" ><VolumeUpOutlinedIcon /></TableCell>
                            <TableCell className="font12 fontWeight800" align="left" sx={{ minWidth: '7vw' }}>Amount</TableCell>
                            <TableCell className="font12 fontWeight800" align="center" sx={{ minWidth: '10vw' }}>Date & Time</TableCell>

                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {
                            deviceTransactionsListMetas?.data?.length > 0 &&

                              deviceTransactionsListMetas?.data?.map((row) => (
                                <TableRow
                                  className="font12"
                                  key={row?.id}
                                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                  <TableCell className="font12" component="th" scope="row">
                                    {crossMarkString(row?.id)}
                                  </TableCell>
                                  <TableCell className="font12" align="center">{getTransactionAnnouncedOrNot(row?.status)}</TableCell>

                                  <TableCell className="font12" align="center" >
                                    <Stack direction="row" alignItems="center">
                                      <CurrencyRupeeIcon sx={{ fontSize: '14px' }} />
                                      <Typography className="font12" sx={{ textAlign: 'center' }}> {row?.amount}</Typography>
                                    </Stack>
                                  </TableCell>
                                  <TableCell className="font12" align="center">{isoDateFToNow(row?.payment_date)}</TableCell>
                                </TableRow>
                              ))
                          }
                        </TableBody>
                      </Table>
                    </TableContainer>

                  </TabPanel>
                  <TabPanel value="all" >

                    <TableContainer sx={{ maxHeight: 350, overflow: 'scroll', }} ref={transacTableRef} onScroll={handleScroll}>
                      <Table aria-label="transactions table" stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell className="font12 fontWeight800">Trans. ID</TableCell>
                            <TableCell className="font12 fontWeight800" align="center" ><VolumeUpOutlinedIcon /></TableCell>
                            <TableCell className="font12 fontWeight800" align="left" sx={{ minWidth: '7vw' }}>Amount</TableCell>
                            <TableCell className="font12 fontWeight800" align="center" sx={{ minWidth: '10vw' }}>Date & Time</TableCell>

                          </TableRow>
                        </TableHead>
                        <TableBody>

                          {
                            deviceTransactionsListMetas?.data?.length > 0 &&
                              deviceTransactionsListMetas?.data?.map((row) => (
                                <TableRow
                                  className="font12"

                                  key={row?.id}
                                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                  <TableCell className="font12" component="th" scope="row">
                                    {crossMarkString(row?.id)}
                                  </TableCell>
                                  <TableCell className="font12" align="center">{getTransactionAnnouncedOrNot(row?.status)}</TableCell>

                                  <TableCell className="font12" align="center" >
                                    <Stack direction="row" alignItems="center">
                                      <CurrencyRupeeIcon sx={{ fontSize: '14px' }} />
                                      <Typography className="font12" sx={{ textAlign: 'center' }}> {row?.amount}</Typography>
                                    </Stack>
                                  </TableCell>
                                  <TableCell className="font12" align="center">{isoDateFToNow(row?.payment_date)}</TableCell>
                                </TableRow>
                              ))                            
                          }

                        </TableBody>
                      </Table>
                    </TableContainer>

                  </TabPanel>
                </TabContext>
              </Box>
              <Box sx={{ mt: 3, position: 'absolute', bottom: 0, justifyContent: 'center', backgroundColor: 'rgba(195, 10, 10, .1)', width: '100%' }}>
                  <Tooltip title={totalAmount} arrow>
                      <Typography sx={{ textAlign: 'center', p: 1, fontSize: 16, fontWeight: 700 }}>
                          Total Amount : Rs. {fShortenNumber(totalAmount)}
                      </Typography>
                  </Tooltip>
                  {deviceTransactionsListMetas?.loading && <LinearProgress color="success" />}
              </Box>
            </Card>
          </Grid>
        </Grid>

        <AlertDialog openAlertDialog={openAlertDialog} message={alertDialogMetas?.message} title={alertDialogMetas?.title}
          btnLabel={alertDialogMetas?.btnLabel} handleClose={() => setOpenAlertDialog(false)} />
        <DeviceLanguageChangeModal opneAssignedModal={isDeviceLangugeChangeModalOpen} handleClose={() => setIsDeviceLangugeChangeModalOpen(false)}
          merchantData={deviceDetails?.data} onAction={(d) => onDeviceLanguageChangeModalAction(d)} />

        <Dialog
          sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
          maxWidth="xs"
          open={isRebootRequestDialogOpen}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleRebootConfirmDialogClose}
        >
          <DialogTitle>Device Reboot</DialogTitle>
          <DialogContent >
            Are you sure want to reboot ?
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleRebootConfirmDialogClose}>
              Cancel
            </Button>
            <Button onClick={() => {
              rebootDevice(deviceDetails?.data?.id, 
                deviceDetails?.data?.device_id); handleRebootConfirmDialogClose()
            }}>Yes, Reboot</Button>
          </DialogActions>
        </Dialog>


      </Container>
    </Page>
  );
}
